export enum EnumTipoTabGestaoCobranca {
  GESTAO_COBRANCA = "Gestão de cobranças",
  AGENDAMENTO = "Agendamentos",
  PROCESSOS_JUDICIAIS = "Processos judiciais",
}
